import { Avatar } from '@genie-fintech/ui/components'
import {
  badgeContainer,
  container,
  email as emailStyle,
  flexColumn,
  name as nameStyle,
  userId as userIdStyle,
  userIDCard
} from './styles.css'
import { footnote } from '@genie-fintech/ui/style/typography'
import CopyButton from '$components/CopyButon/v2'
import { useProfileDataStore } from '../../hooks/useProfileDataStore'
import { useShallow } from 'zustand/react/shallow'
import { status } from '@genie-fintech/ui/style/element'
import { FC } from 'react'

type Props = {
  hideEmail?: boolean
  hideVerifyBadge?: boolean
}

const ProfileCard: FC<Props> = ({ hideEmail, hideVerifyBadge }) => {
  const profile = useProfileDataStore(useShallow(state => state.profile))

  return (
    <article className={container}>
      <article className={flexColumn} style={{ gap: 8, alignItems: 'center' }}>
        <Avatar size={40} status={'online'} />

        <article className={flexColumn} style={{ alignItems: 'center' }}>
          <p className={nameStyle}>{profile?.name}</p>
          {!hideEmail && <p className={emailStyle}>{profile?.email}</p>}
        </article>

        <article className={badgeContainer}>
          {!!profile?.status && (
            <span
              className={status({
                type: 'faint',
                kind: profile.status === 'active' ? 'success' : 'grey',
                size: 'tiny'
              })}
              style={{ textTransform: 'uppercase' }}
            >
              {profile.status}
            </span>
          )}

          {!!profile?.user_type && (
            <span
              className={status({
                type: 'faint',
                kind:
                  profile.user_type === 'internal' ? 'secondary' : 'primary',
                size: 'tiny'
              })}
              style={{ textTransform: 'uppercase' }}
            >
              {profile.user_type}
            </span>
          )}
        </article>

        <article className={badgeContainer}>
          {!hideVerifyBadge && (
            <>
              <span
                className={status({
                  type: 'faint',
                  kind: profile?.email_verified_at ? 'success' : 'warning',
                  size: 'tiny'
                })}
                style={{ textTransform: 'uppercase' }}
              >
                {profile?.email_verified_at
                  ? 'Email verified'
                  : 'Email unverified'}
              </span>

              <span
                className={status({
                  type: 'faint',
                  kind: profile?.is_phone_verified ? 'success' : 'warning',
                  size: 'tiny'
                })}
                style={{ textTransform: 'uppercase' }}
              >
                {profile?.is_phone_verified
                  ? 'Phone verified'
                  : 'Phone unverified'}
              </span>
            </>
          )}
        </article>
      </article>

      <article className={userIDCard}>
        <span className={footnote.two}>User ID</span>

        <span className={userIdStyle}>{`#${profile?.id}`}</span>

        <CopyButton
          size={16}
          value={`${profile?.id ?? ''}`}
          color="text.neutral"
        />
      </article>
    </article>
  )
}

export default ProfileCard
